import type { ReactElement } from 'react';
import Cart from 'models/Cart';
import Alert from '../Alert';

type Props = { cart: Cart; };

function GenericAlert({ cart }: Props): ReactElement {
  return (
    <Alert type={cart?.alert?.type}>
      {cart?.alert?.message}
    </Alert>
  );
}

export default GenericAlert;
